import { render, staticRenderFns } from "./BusinessHour.vue?vue&type=template&id=2f5ae7e0&scoped=true"
import script from "./BusinessHour.vue?vue&type=script&lang=js"
export * from "./BusinessHour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5ae7e0",
  null
  
)

export default component.exports